export const safeDisableMultimediaKeys = () => {
  if (navigator.mediaSession && typeof navigator.mediaSession.setActionHandler === 'function') {
    navigator.mediaSession.setActionHandler('play', () => {});
    navigator.mediaSession.setActionHandler('pause', () => {});
    navigator.mediaSession.setActionHandler('stop', () => {});
    navigator.mediaSession.setActionHandler('seekbackward', () => {});
    navigator.mediaSession.setActionHandler('seekforward', () => {});
    navigator.mediaSession.setActionHandler('seekto', () => {});
    navigator.mediaSession.setActionHandler('previoustrack', () => {});
    navigator.mediaSession.setActionHandler('nexttrack', () => {});
  }
};

export const safeEnableMulimediaKeys = () => {
  if (navigator.mediaSession && typeof navigator.mediaSession.setActionHandler === 'function') {
    navigator.mediaSession.setActionHandler('play', null);
    navigator.mediaSession.setActionHandler('pause', null);
    navigator.mediaSession.setActionHandler('stop', null);
    navigator.mediaSession.setActionHandler('seekbackward', null);
    navigator.mediaSession.setActionHandler('seekforward', null);
    navigator.mediaSession.setActionHandler('seekto', null);
    navigator.mediaSession.setActionHandler('previoustrack', null);
    navigator.mediaSession.setActionHandler('nexttrack', null);
  }
};

export const safeSetMediaPlaybackState = (state) => {
  const { mediaSession } = navigator;

  if (mediaSession) {
    if (state === 'none') {
      mediaSession.metadata = null;
    }
    mediaSession.playbackState = state;
  }
};

export const createInvisibleAudioElementFromMedia = (mediaSrc, id) => {
  const audio = new Audio(mediaSrc);

  audio.id = id;
  audio.controls = false;

  return audio;
};



// WEBPACK FOOTER //
// ./utils/media-session.js